module.exports = __webpack_public_path__ + "media/swords.0b819f19.mp3";